<template>
  <a-modal
    :title="!dataForm.id ? '新增' : '修改'"
    :close-on-click-modal="false"
    :visible.sync="visible"
    width="700px"
    :visible="visible"
    @cancel="handleCancel"
    @ok="handleOk"
  >
    <a-form-model
      layout="inline"
      :model="dataForm"
      :rules="dataRule"
      ref="dataForm"
    >
      <a-form-model-item label="规则名称" prop="ruleName">
        <a-input v-model="dataForm.ruleName" placeholder="规则名称"></a-input>
      </a-form-model-item>
      <a-form-model-item label="匹配词" prop="matchValue">
        <template v-for="(tag, index) in dataForm.matchValue">
          <a-tooltip v-if="tag.length > 20" :key="tag" :title="tag">
            <a-tag
              :key="tag"
              :closable="index == 0"
              @close="() => handleClose(tag)"
            >
              {{ `${tag.slice(0, 20)}...` }}
            </a-tag>
          </a-tooltip>
          <a-tag
            v-else
            :key="tag"
            :closable="index == 0"
            @close="() => handleClose(tag)"
          >
            {{ tag }}
          </a-tag>
        </template>
        <a-input
          v-if="inputVisible"
          ref="input"
          type="text"
          size="small"
          :style="{ width: '78px' }"
          :value="inputValue"
          @change="handleInputChange"
          @blur="handleInputConfirm"
          @keyup.enter="handleInputConfirm"
        />
        <a-tag v-else color="blue" @click="showInput">
          <a-icon type="plus" /> 添加
        </a-tag>
      </a-form-model-item>
      <a-row>
        <a-col :span="12">
          <a-form-model-item label="作用范围" prop="appid">
            <a-select v-model="dataForm.appid" placeholder="作用范围">
              <a-select-option
                value=""
                v-if="this.dataForm.replyType === 'text'"
                >全部公众号</a-select-option
              >
              <a-select-option
                :value="this.wechatAppId"
                v-if="!!this.wechatAppId"
                >当前公众号</a-select-option
              >
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="精确匹配" prop="exactMatch">
            <a-switch
              v-model="dataForm.exactMatch"
              :checked-children="true"
              :un-checked-children="false"
            ></a-switch>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="12">
          <a-form-model-item label="回复类型" prop="replyType">
            <a-select v-model="dataForm.replyType" @change="onReplyTypeChange">
              <a-select-option
                v-for="(name, key) in KefuMsgType"
                :key="key"
                :value="key"
                >{{ name }}</a-select-option
              >
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="是否启用" prop="status">
            <a-switch
              v-model="dataForm.status"
              :checked-children="true"
              :un-checked-children="false"
            ></a-switch>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="12">
          <a-form-model-item label="生效时间" prop="effectTimeStart">
            <a-time-picker
              v-model="dataForm.effectTimeStart"
              format="HH:mm:ss"
              @change="timeStartChange"
            ></a-time-picker>
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="失效时间" prop="effectTimeEnd">
            <a-time-picker
              v-model="dataForm.effectTimeEnd"
              format="HH:mm:ss"
              @change="timeEndChange"
            ></a-time-picker>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-form-model-item label="回复内容" prop="replyContent">
        <a-input
          v-model="dataForm.replyContent"
          type="textarea"
          :rows="5"
          placeholder="文本、图文ID、media_id、json配置"
        ></a-input>
        <a-button
          type="text"
          v-show="'text' == dataForm.replyType"
          @click="addLink"
          >插入链接</a-button
        >
        <a-button
          type="text"
          v-show="assetsType"
          @click="assetsSelectorVisible = true"
        >
          从素材库中选择<span
            v-if="
              'miniprogrampage' == dataForm.replyType ||
                'music' == dataForm.replyType
            "
            >缩略图</span
          >
        </a-button>
      </a-form-model-item>
      <a-form-model-item label="备注说明" prop="describe">
        <a-input v-model="dataForm.describe" placeholder="备注说明"></a-input>
      </a-form-model-item>
    </a-form-model>
    <assets-selector
      v-if="assetsSelectorVisible && assetsType"
      :visible="assetsSelectorVisible"
      :selectType="assetsType"
      @selected="onAssetsSelect"
    ></assets-selector>
  </a-modal>
</template>

<script>
import { mapState } from 'vuex';
import moment from 'moment';
import { getAction, postAction } from '@/api/manage';
export default {
  props: {
    wechatAppId: {
      type: String,
      required: true
    }
  },
  components: {
    /*      tagsEditor: () => import('@/components/tags-editor'),
        AssetsSelector:()=>import('./assets/assets-selector')*/
  },
  data() {
    return {
      visible: false,
      assetsSelectorVisible: false,
      tags: [],
      inputVisible: false,
      inputValue: '',
      dataForm: {
        id: 0,
        appid: '',
        ruleName: '',
        exactMatch: false,
        matchValue: [],
        replyType: 'text',
        replyContent: '',
        status: true,
        describe: '',
        effectTimeStart: '',
        effectTimeEnd: ''
      },
      KefuMsgType: {
        text: '文本消息',
        image: '图片消息',
        voice: '语音消息',
        video: '视频消息',
        music: '音乐消息',
        news: '文章链接',
        mpnews: '公众号图文消息',
        wxcard: '卡券消息',
        miniprogrampage: '小程序消息',
        msgmenu: '菜单消息'
      },
      dataRule: {
        ruleName: [
          { required: true, message: '规则名称不能为空', trigger: 'blur' }
        ],
        matchValue: [
          {
            required: true,
            message: '匹配的关键词、事件等不能为空',
            trigger: 'blur'
          }
        ],
        replyType: [
          {
            required: true,
            message: '回复类型（1:文本2:图文3媒体）不能为空',
            trigger: 'blur'
          }
        ],
        replyContent: [
          { required: true, message: '回复内容不能为空', trigger: 'blur' }
        ],
        status: [
          { required: true, message: '是否有效不能为空', trigger: 'blur' }
        ],
        effectTimeStart: [
          { required: true, message: '生效起始时间不能为空', trigger: 'blur' }
        ],
        effectTimeEnd: [
          { required: true, message: '生效结束时间不能为空', trigger: 'blur' }
        ]
      }
    };
  },
  computed: mapState({
    //selectedAppid:state=>state.wxAccount.selectedAppid,
    assetsType() {
      const config = {
        //消息类型与选择素材类型对应关系
        image: 'image',
        voice: 'voice',
        video: 'video',
        mpnews: 'news',
        miniprogrampage: 'image', //小程序需选择卡片图
        music: 'image'
      };
      return config[this.dataForm.replyType] || '';
    }
  }),
  methods: {
    moment,
    timeStartChange(timeString) {
      this.dataForm.effectTimeStart = timeString;
    },
    timeEndChange(timeString) {
      this.dataForm.effectTimeEnd = timeString;
    },
    handleClose(removedTag) {
      const tags = this.tags.filter(tag => tag !== removedTag);
      this.tags = tags;
      this.dataForm.matchValue = tags;
    },
    showInput() {
      this.inputVisible = true;
      this.$nextTick(function() {
        this.$refs.input.focus();
      });
    },
    handleInputChange(e) {
      this.inputValue = e.target.value;
    },
    handleInputConfirm() {
      const inputValue = this.inputValue;
      let tags = this.dataForm.matchValue;
      if (inputValue && tags.indexOf(inputValue) === -1) {
        tags = [...tags, inputValue];
      }
      console.log(tags);
      Object.assign(this, {
        tags,
        inputVisible: false,
        inputValue: ''
      });
      this.dataForm.matchValue = tags;
    },
    handleOk(e) {
      this.dataFormSubmit();
    },
    handleCancel(e) {
      this.visible = false;
      this.$refs.dataForm.resetFields();
      this.dataForm.effectTimeStart = moment('00:00:00', 'HH:mm:ss');
      this.dataForm.effectTimeEnd = moment('23:59:59', 'HH:mm:ss');
    },
    init(id) {
      this.dataForm.id = id || '';
      this.dataForm.effectTimeStart = moment('00:00:00', 'HH:mm:ss');
      this.dataForm.effectTimeEnd = moment('23:59:59', 'HH:mm:ss');
      this.visible = true;
      this.$nextTick(() => {
        //this.$refs["dataForm"].resetFields();
        if (this.dataForm.id) {
          getAction(
            process.env.VUE_APP_CMS_WECHAT +
              `/manage/msgReplyRule/info/${this.dataForm.id}`
          ).then(res => {
            if (res.success && res.code === 200) {
              this.dataForm = res.result;
              this.dataForm.matchValue = res.result.matchValue.split(',');
              this.dataForm.effectTimeStart = moment(
                res.result.effectTimeStart,
                'HH:mm'
              );
              this.dataForm.effectTimeEnd = moment(
                res.result.effectTimeEnd,
                'HH:mm'
              );
            }
          });
        }
      });
    },
    // 表单提交
    dataFormSubmit() {
      let data = JSON.parse(JSON.stringify(this.dataForm));
      let matchValueList = data.matchValue;
      let matchValue = '';
      for (let i in matchValueList) {
        matchValue += matchValueList[i] + ',';
      }
      if (matchValue.length > 0) {
        matchValue = matchValue.substr(0, matchValue.length - 1);
      }
      data.matchValue = matchValue;
      data.effectTimeStart = moment(data.effectTimeStart).format('HH:mm:ss');
      data.effectTimeEnd = moment(data.effectTimeEnd).format('HH:mm:ss');
      this.$refs.dataForm.validate(valid => {
        if (valid) {
          this.$http({
            url:
              process.env.VUE_APP_CMS_WECHAT +
              `/manage/msgReplyRule/${!data.id ? 'save' : 'update'}`,
            method: 'post',
            data: data
          }).then(res => {
            if (res.success && res.code === 200) {
              this.$message.success('操作成功');
              this.visible = false;
              this.$emit('refreshDataList');
            } else {
              this.$message.error(res.message);
            }
          });
        }
      });
    },
    addLink() {
      this.dataForm.replyContent += '<a href="链接地址">链接文字</a>';
    },
    onReplyTypeChange(value) {
      if ('miniprogrampage' == value) {
        let demo = {
          title: '标题',
          appid: '小程序APPID',
          pagepath: '页面地址',
          thumb_media_id: '缩略图media_id'
        };
        this.dataForm.replyContent = JSON.stringify(demo, null, 4);
      } else if ('music' == value) {
        let demo = {
          musicurl: '音乐链接',
          hqmusicurl: '高品质链接',
          title: '标题',
          description: '描述',
          thumb_media_id: '缩略图media_id'
        };
        this.dataForm.replyContent = JSON.stringify(demo, null, 4);
      } else if ('msgmenu' == value) {
        let demo = {
          head_content: '开头文字',
          list: [
            { id: '菜单1ID', content: '菜单2内容' },
            { id: '菜单2ID', content: '菜单2内容' },
            { id: '菜单nID', content: '菜单n内容' }
          ],
          tail_content: '结尾文字'
        };
        this.dataForm.replyContent = JSON.stringify(demo, null, 4);
      } else if ('news' == value) {
        let demo = {
          title: '文章标题',
          description: '文章简介',
          url: '链接URL',
          picUrl: '缩略图URL'
        };
        this.dataForm.replyContent = JSON.stringify(demo, null, 4);
      } else {
        this.dataForm.replyContent = '媒体素材media_id';
      }
    },
    onAssetsSelect(assetsInfo) {
      if (
        this.dataForm.replyType == 'miniprogrampage' ||
        this.dataForm.replyType == 'music'
      ) {
        let data = JSON.parse(this.dataForm.replyContent);
        if (data && data.thumb_media_id)
          data.thumb_media_id = assetsInfo.mediaId;
        this.dataForm.replyContent = JSON.stringify(data, null, 4);
      } else {
        this.dataForm.replyContent = assetsInfo.mediaId;
      }
      this.assetsSelectorVisible = false;
    }
  }
};
</script>
